<app-dynamic-form
  [dynamicFormOptions]="dynamicFormOptions"
  (formSubmitted)="onFormSubmitted($event)"
  [formInitialData]="formInitialData"
  [isSubmitting]="isSubmitting"
  [successMessage]="successMessage"
  (itemDeleted)="onItemDeleted()"
>
</app-dynamic-form>
